module.exports = __webpack_public_path__ + "static/media/gallery4.fda35113.png";